<template>
  <div v-if="total > 0" class="flex flex-wrap items-center justify-between gap-4 border-t border-gray-200 bg-white px-4 py-3 text-sm">
    <div class="flex flex-wrap items-center gap-4 text-gray-600">
      <span>
        {{ t('Показано') }} <span class="font-medium text-gray-900">{{ firstItem }}–{{ lastItem }}</span>
        {{ t('из') }} <span class="font-medium text-gray-900">{{ total }}</span>
      </span>
      <label class="flex items-center gap-2">
        <span>{{ t('На странице:') }}</span>
        <select :value="pageSize" class="rounded-md border border-gray-300 bg-white px-2 py-1 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" @change="$emit('update:page-size', Number($event.target.value))">
          <option v-for="size in pageSizeOptions" :key="size" :value="size">{{ size }}</option>
        </select>
      </label>
    </div>

    <nav v-if="totalPages > 1" class="flex items-center gap-1" :aria-label="t('Пагинация')">
      <button type="button" :disabled="page <= 1" class="page-button" :aria-label="t('Предыдущая страница')" @click="$emit('change', page - 1)">
        <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" /></svg>
      </button>
      <template v-for="(item, index) in visiblePages" :key="`${item}-${index}`">
        <span v-if="item === '…'" class="px-2 py-1 text-gray-500">…</span>
        <button
          v-else
          type="button"
          class="page-button"
          :class="item === page ? '!border-blue-600 !bg-blue-600 !text-white' : ''"
          :aria-current="item === page ? 'page' : undefined"
          @click="$emit('change', item)"
        >{{ item }}</button>
      </template>
      <button type="button" :disabled="page >= totalPages" class="page-button" :aria-label="t('Следующая страница')" @click="$emit('change', page + 1)">
        <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
      </button>
    </nav>
  </div>
</template>

<script>
import { t } from '@/i18n'

export default {
  name: 'StaffPagination',
  props: {
    page: { type: Number, default: 1 },
    pageSize: { type: Number, default: 20 },
    total: { type: Number, default: 0 },
    pageSizeOptions: { type: Array, default: () => [20, 50, 100] }
  },
  emits: ['change', 'update:page-size'],
  computed: {
    totalPages() { return Math.max(1, Math.ceil(this.total / this.pageSize)) },
    firstItem() { return this.total ? (this.page - 1) * this.pageSize + 1 : 0 },
    lastItem() { return Math.min(this.page * this.pageSize, this.total) },
    visiblePages() {
      if (this.totalPages <= 7) return Array.from({ length: this.totalPages }, (_, index) => index + 1)
      const pages = [1]
      if (this.page > 4) pages.push('…')
      const start = Math.max(2, this.page - 1)
      const end = Math.min(this.totalPages - 1, this.page + 1)
      for (let current = start; current <= end; current += 1) pages.push(current)
      if (this.page < this.totalPages - 3) pages.push('…')
      pages.push(this.totalPages)
      return pages
    }
  },
  methods: {
    t
  }
}
</script>

<style scoped>
.page-button { @apply flex min-h-[32px] min-w-[32px] items-center justify-center rounded border border-gray-300 bg-white px-2 py-1 text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400; }
</style>
